import { createContext } from "preact";
import {useState} from "preact/hooks";
import Alert from "../components/alert";

export const AlertContext = createContext({});

export const AlertProvider = ({children}) => {
  const [alert, setAlert] = useState(null);
  const [renderAlert, setRenderAlert] = useState(null);

  const showAlertComponent = renderFunction => {
    setRenderAlert(renderFunction);
  };

  const showAlert = (title, message, options) => {
    setAlert({title, message, options});
  };

  const hideAlert = () => {
    setRenderAlert(null);
    setAlert(null);
  };

  return <AlertContext.Provider value={{
    showAlertComponent,
    showAlert,
    hideAlert
  }}>
    {children}
    {alert && <Alert onDismiss={hideAlert} title={alert.title} message={alert.message} options={alert.options} component={renderAlert} />}
    {renderAlert && <Alert onDismiss={hideAlert} component={renderAlert} />}
  </AlertContext.Provider>;
};

export const withAlert = (Component) => {
  return function AlertComponent(props) {
    return <AlertContext.Consumer>
      {ctx => <Component {...props} alert={ctx} />}
    </AlertContext.Consumer>;
  }
}



// WEBPACK FOOTER //
// ./contexts/AlertContext.js